import React from 'react';
import { graphql } from 'gatsby';
import { IntroPage, NavigationSub, Page } from '@mq/gatsby-components';

import IndexLayout from '../layouts';

import ComponentBlocks from '../containers/ComponentBlocks';

import { IntroSectionBlock } from '@mq/generated-types/dist/IntroSectionBlock';
import {
  CampaignPage,
  CampaignPage_craft_campaign_Craft_campaigns_campaigns_Entry as CampaignEntry,
} from '@mq/generated-types/dist/CampaignPage';

import { isQA, getMostRecentDraft } from '../utils/misc';

interface CraftData {
  data: CampaignPage;
}

const CampaignTemplate: React.FC<CraftData> = ({ data }) => {
  const { campaign, drafts } = data.craft;

  let typedCampaignPage = campaign as CampaignEntry;
  const typedDrafts = drafts as CampaignEntry[];

  if (isQA && typedDrafts.length) {
    typedCampaignPage = getMostRecentDraft(typedDrafts);
  }
  const navigationContent = typedCampaignPage.pageBlocks?.filter(
    (block) => block?.__typename === 'Craft_pageBlocks_introSection_BlockType',
  );

  return (
    <IndexLayout>
      <Page>
        <IntroPage
          craft={{
            blockTitle: typedCampaignPage.title,
            audience: ['public', 'p', 'i'],
            ...typedCampaignPage,
          }}
        />
        {typedCampaignPage.hasAnchorNav && (
          <NavigationSub
            list={(navigationContent as IntroSectionBlock[]).map((a) => ({
              id: a.id || '',
              title: a.blockTitle || '',
            }))}
          />
        )}
        <ComponentBlocks pageBlocks={typedCampaignPage.pageBlocks} />
      </Page>
    </IndexLayout>
  );
};

export default CampaignTemplate;

export const CampaignEntryFragment = graphql`
  fragment CampaignEntry on Craft_campaigns_campaigns_Entry {
    id
    title
    description
    primaryButtonLabel
    primaryButtonLink
    secondaryButtonLabel
    secondaryButtonLink
    dateUpdated
    foregroundImage {
      ...Asset
    }
    backgroundImage {
      ...Asset
    }
    hasAnchorNav

    pageBlocks {
      ...PageBlocks
    }
  }
`;

export const CampaignPageQuery = graphql`
  query CampaignPage($slug: [String]!) {
    craft {
      campaign: entry(slug: $slug, type: "campaigns") {
        ...CampaignEntry
      }
      drafts: entries(slug: $slug, type: "campaigns", drafts: true) {
        ...CampaignEntry
      }
    }
  }
`;
